/*
  Hidden Recharge subscription widget for the arb-ss builder and the arb-pdp product page.

  The pages keep their own UI. This mounts the theme's <sms-recharge-widget> (the Recharge
  widget the original Subscribe & Save page uses) in a hidden holder for the selected product
  and variant, keeps it pointed at the current selection, and hands back the selling plan
  Recharge lists for the chosen delivery frequency so that is what goes to the cart.

  If the widget isn't ready (still loading, or Recharge can't be reached) plan() returns null
  and the page sends the plan from the product's Shopify data, which is the same Recharge plan.

  Usage:
    ArbRecharge.mount(holder, productId, variantId)
    ArbRecharge.plan(holder, wantedPlanId, intervalDays)  -> plan id or null
*/
(function () {
  if (window.ArbRecharge) return;

  function days(text) {
    var m = /(\d+)\s*-?\s*(day|week|month)/i.exec(String(text || ''));
    if (!m) return null;
    var u = m[2].toLowerCase();
    return +m[1] * (u === 'day' ? 1 : u === 'week' ? 7 : 30);
  }

  function mount(holder, productId, variantId) {
    if (!holder || !productId || !variantId) return;
    var el = holder.querySelector('sms-recharge-widget');
    if (el && el.getAttribute('productid') === String(productId)) {
      // same product: the widget re-prices itself when its variant changes
      if (el.getAttribute('variantid') !== String(variantId)) el.setAttribute('variantid', String(variantId));
      return;
    }
    // new product: the widget only loads product data when it's first connected, so start a fresh one
    holder.innerHTML = '';
    el = document.createElement('sms-recharge-widget');
    el.setAttribute('productid', String(productId));
    el.setAttribute('variantid', String(variantId));
    el.setAttribute('formid', 'arb-rc-' + productId);
    holder.appendChild(el);
  }

  function plan(holder, wantedId, wantedDays) {
    var el = holder && holder.querySelector('sms-recharge-widget');
    var field = el && el.querySelector('[name="selling_plan"]');
    if (!field) return null;
    if (field.tagName !== 'SELECT') return Number(field.value) || null;
    var opts = Array.prototype.slice.call(field.options);
    var pick = opts.filter(function (o) { return Number(o.value) === Number(wantedId); })[0];
    if (!pick && wantedDays) pick = opts.filter(function (o) { return days(o.textContent) === wantedDays; })[0];
    if (!pick) return null;
    if (field.value !== pick.value) {
      // keep the hidden widget showing the frequency picked in the page UI
      field.value = pick.value;
      field.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return Number(pick.value) || null;
  }

  window.ArbRecharge = { mount: mount, plan: plan };
})();
